module.exports = __webpack_public_path__ + "img/2.a18d77c7.png";